import {AutoLoading} from "./AutoLoading";

export class AutoLoadingSelection extends AutoLoading{

  constructor($wrapper, type) {
    super($wrapper, type)
  }

  actions(button, html) {
    this.updateSlider(html);
    this.changeClass(button);
    this.loading(false);
  }

  changeClass(button) {
    [].filter.call(button.parentNode.children, child => {
      if (child !== button) {
        child.classList.remove('is-active');
      } else {
        child.classList.add('is-active');
      }
    });
  }

  updateSlider(html) {
    const slider = this.$container.querySelector('.swiper-container').swiper;
    slider.removeAllSlides();
    let el = document.createElement('div');
    el.innerHTML = html;
    let items = el.querySelectorAll('.swiper-slide');
    slider.appendSlide(items);
  }

}
